import React from 'react';
import { Col, Row, Space } from 'antd';
import { I18n } from '@aws-amplify/core';

import type { BeraReportV2Scores } from '@/types/Bera';

import { ScoreRow } from './ScoreRow';
import { RpnChip, RpnLabel, ScoresColumn } from './styles';

const SCORE_GUTTER = 8;
const RPN_GUTTER = 34;

interface ScoresProps {
	scores: BeraReportV2Scores;
}

export function Scores({ scores }: Readonly<ScoresProps>): JSX.Element {
	return (
		<ScoresColumn>
			<Space direction="vertical" size={SCORE_GUTTER}>
				<ScoreRow label={I18n.get('Gravity')} value={scores.severity} />
				<ScoreRow label={I18n.get('Exposure')} value={scores.exposure} />
				<ScoreRow label={I18n.get('Probability')} value={scores.vulnerability} />
			</Space>
			<Row align="middle" gutter={[RPN_GUTTER, 0]} wrap={false}>
				<Col>
					<RpnLabel>{I18n.get('Risk Priority Number (RPN)')}</RpnLabel>
				</Col>
				<Col>
					<RpnChip>{scores.rpn}</RpnChip>
				</Col>
			</Row>
		</ScoresColumn>
	);
}
